import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=74f615fc&"
import script from "./mark.vue?vue&type=script&lang=js&"
export * from "./mark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports